// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__FMPm6 {
  cursor: pointer; }
  .styles_container__FMPm6 button::before {
    content: "+";
    font-size: 1.8rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Card/AddCard/styles.module.scss"],"names":[],"mappings":"AACA;EACE,eAAe,EAAA;EADjB;IAIM,YAAY;IACZ,iBAAiB,EAAA","sourcesContent":["\n.container {\n  cursor: pointer;\n  & button {\n    &::before {\n      content: \"+\";\n      font-size: 1.8rem;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__FMPm6`
};
export default ___CSS_LOADER_EXPORT___;
